module.exports = new __parcel__URL__("oyster.ad23795d.svg").toString();